<template>
  <div>
    <el-divider class="cml-divider" content-position="center">审批用户配置</el-divider>
    <el-form
      class="cml-search-form"
      ref="listForm"
      :inline="true"
      size="mini"
    >
      <el-form-item label="登录名">
        <el-input
          v-model.trim="formData.loginName"
          @keyup.13.native="onSearch"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="花名">
        <el-input
          v-model.trim="formData.name"
          @keyup.13.native="onSearch"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button  @click="onReset">清空</el-button>
      </el-form-item>
    </el-form>
    <div class="cml-button-group">
      <el-button type="primary" @click="addBtn">新增</el-button>
    </div>
    <CommonTable
      ref="CommonTableRef"
      :showPage="false"
      :showCheckbox="false"
      :loading="tableLoading"
      :tableHead="tableHead"
      :tableData="tableData"
      :tableParam="formData"
    >
      <template #operationSlot="{ row }">
        <el-button
          type="text"
          @click="deleteBtn(row)"
          v-hasPermission="'sample-manage/sample-verify-btn'"
          >删除</el-button
        >
      </template>
    </CommonTable>
    <el-dialog
      title="新增"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="30%"
    >
      <el-form>
        <el-form-item label="花名" required>
          <el-select
            v-model="name"
            remote
            filterable
            placeholder="请选择花名"
            :remote-method="remoteMethod"
            @change="nameChange"
          >
            <el-option
              v-for="item in userOptions"
              :key="item.account"
              :label="item.loginName"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button
          type="primary"
          @click="createBtn"
          size="mini"
          :loading="saveLoading"
          >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CommonTable from '@/components/CommonTable';

export default {
  name: 'approval-user',
  components: {
    CommonTable
  },
  data() {
    return {
      name: '',
      userOptions: [],
      dialogVisible: false,
      tableLoading: false,
      saveLoading: false,
      formData: {
        name: '',
        loginName: '',
      },
      tableData: {
        list: []
      },
      tableHead: [
        { prop: 'loginName', label: '登录名' },
        { prop: 'name', label: '花名' },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 100,
        }
      ],
      createForm: {
        name: '',
        loginName: ''
      }
    };
  },
  mounted() {
    this.getUser();
    this.$refs.CommonTableRef.changeHeight(35);
  },
  methods: {
    addBtn () {
      this.dialogVisible = true;
      this.name = '';
      this.createForm = {
        name: '',
        loginName: ''
      }
    },
    deleteBtn (row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.leadApprovalConfig.deleteApprovalUser(row.id).then(res => {
          this.$message.success(res.msg);
          this.dialogVisible = false;
          this.createForm = {
            name: '',
            loginName: ''
          }
          this.getUser();
        })
      })
    },
    nameChange (item) {
      if(!item.account) return false;
      this.createForm = {
        name: item.loginName,
        loginName: item.account
      }
    },
    createBtn () {
      if(!this.createForm.name) {
        this.$message.error('花名不能为空');
        return false;
      }
      this.saveLoading = true;
      this.$http.leadApprovalConfig.createApprovalUser(this.createForm).then(res => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.createForm = {
          name: '',
          loginName: ''
        }
        this.getUser();
      }).catch(err => {
        this.$message.error(err.msg);
      }).finally(() => {
        this.saveLoading = false;
      })
    },
    remoteMethod (query) {
      if (!query.trim()) {
        this.userOptions = [];
        return false;
      }
      this.$http.user.getUserListAll({
        loginName: query
      }).then(res => {
        this.userOptions = res.data;
      })
    },
    onSearch() {
      this.getUser();
    },
    getUser() {
      this.tableLoading = true
      this.$http.leadApprovalConfig
        .userList(this.formData)
        .then(result => {
          this.tableData.list = result.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        }).finally(() => {this.tableLoading = false})
    },
    onReset() {
      this.formData.name = '';
      this.formData.loginName = '';
    }
  },
};
</script>
